export const TYPES = { ActaService: Symbol('ActaService')
};
